@if (isLoading) {
  <div class="loading-container">
    <motn-spinner></motn-spinner>
  </div>
} @else if (allUserSimpleTiles) {
  <div class="sorter">
    <motn-tile-order-sorter
      [tiles]="allUserSimpleTiles"
      [dataPoints]="dataPoints"
      [isDataPointsViewMode]="isDataPointsViewMode"
      [tileOrder]="orderedTileIds()"
      [selectableTilesOptionGroup]="selectableTilesOptionGroup"
      (clickedX$)="removeTile($event)"
      (draggedAndDropped$)="drop($event)"
      (sortedById$)="onSortedById($event)"
      (hiddenDataPointsUpdate$)="onHiddenDataPointsUpdate($event)"
    ></motn-tile-order-sorter>
  </div>
}
